// extracted by mini-css-extract-plugin
export default {"green":"JOr4TOJXjxNzN3uvWxu7","dipper":"QYVL0VUL0DOSdvboH61r","placeHolderShimmer":"iT5OHMjqab2pxroinld3"};